export default __webpack_public_path__ + "static/header.morf-e49dd868ec9337a9793fc469f9053733.jpg";